import { useStore } from '@tanstack/react-store'
import { Auth } from 'entities/Auth'
import { Documents } from 'entities/Documents'
import { Logout } from 'entities/Logout'
import { Logo } from 'features/Logo'
import { Private, PrivateRoute } from 'features/Private'
import { ProfileWidget } from 'entities/ProfileWidget'
import { useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ROLES } from 'shared/constants/user'
import { useAuth } from 'shared/hooks/useAuth'
import { authStore } from 'shared/store/auth'
import { ContainerApp, Header, NavigationMenuItem } from 'uikit/layout'
import { Access } from './entities/Access'
import { Payments } from './entities/Payments'
import { Referral } from './entities/Referral'
import { Reports } from './entities/Reports'
import { Services } from './entities/Services'
import { User } from './entities/User'

function App() {
  const { mutate: checkAuth, isPending: authIsloading } = useAuth()
  const { isAuthenticated, user } = useStore(authStore)

  useEffect(() => {
    checkAuth({})
  }, [])

  return (
    <>
      <ContainerApp>
        <Route path="/logout">
          <Logout />
        </Route>

        {!isAuthenticated ? (
          <Auth loading={authIsloading} />
        ) : (
          <>
            <Header
              renderLogo={<Logo w="68px"/>}
              renderNavigationItem={
                <>
                  <Private hasAnyRole={[ROLES.user, ROLES.admin]}>
                    <NavigationMenuItem to="/user" colorPalette="orange">
                      Пользователи
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.user, ROLES.admin]}>
                    <NavigationMenuItem to="/payments" colorPalette="orange">
                      Платежи
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.admin]}>
                    <NavigationMenuItem to="/documents" colorPalette="orange">
                      Документы
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.admin]}>
                    <NavigationMenuItem to="/services" colorPalette="orange">
                      Сервисы
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.admin]}>
                    <NavigationMenuItem to="/referral" colorPalette="orange">
                      Бонусы
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.admin]}>
                    <NavigationMenuItem to="/access" colorPalette="orange">
                      Доступ
                    </NavigationMenuItem>
                  </Private>
                  <Private hasAnyRole={[ROLES.admin]}>
                    <NavigationMenuItem to="/reports" colorPalette="orange">
                      Отчеты
                    </NavigationMenuItem>
                  </Private>
                </>
              }
              renderProfileWidget={<ProfileWidget />}
            />
            <Switch>
              <PrivateRoute path="/user" hasAnyRole={[ROLES.user, ROLES.admin]}>
                <User />
              </PrivateRoute>
              <PrivateRoute path="/payments" hasAnyRole={[ROLES.user, ROLES.admin]}>
                <Payments />
              </PrivateRoute>
              <PrivateRoute path="/documents" hasAnyRole={[ROLES.admin]}>
                <Documents />
              </PrivateRoute>
              <PrivateRoute path="/access" hasAnyRole={[ROLES.admin]}>
                <Access />
              </PrivateRoute>
              <PrivateRoute path="/referral" hasAnyRole={[ROLES.admin]}>
                <Referral />
                <Redirect to="/referral/catalog" />
              </PrivateRoute>
              <PrivateRoute path="/services" hasAnyRole={[ROLES.admin]}>
                <Services />
                <Redirect to="/services/banners" />
              </PrivateRoute>
              <PrivateRoute path="/reports" hasAnyRole={[ROLES.admin]}>
                <Reports />
              </PrivateRoute>
              <Route path="/">
                <Redirect to="/user" />
              </Route>
            </Switch>
          </>
        )}
      </ContainerApp>
    </>
  )
}

export default App
